/**
 * Optional runtime config from Firestore config/publicEnv (public keys only).
 * Populated by scripts/upload-encrypted-env.js. Use getPublicConfig() for
 * Algolia app ID / search key; fallback to process.env when cache is empty.
 * Write keys (e.g. ALGOLIA_WRITE_API_KEY) are never in publicEnv; use process.env.
 */

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

let cached = null;

/**
 * Returns cached public config (sync). Empty until fetchPublicEnv() completes.
 * @returns {Record<string, string>}
 */
export function getPublicConfig() {
  return cached || {};
}

/**
 * Fetches config/publicEnv from Firestore and caches it. Safe to call multiple times.
 * Call early in app (e.g. App.js or AuthProvider) so Algolia can use it when needed.
 * @returns {Promise<Record<string, string>>}
 */
export async function fetchPublicEnv() {
  if (cached) return cached;
  try {
    const snap = await getDoc(doc(db, 'config', 'publicEnv'));
    if (snap.exists() && snap.data()) {
      const data = snap.data();
      const out = {};
      Object.keys(data).forEach((k) => {
        if (k !== 'updatedAt' && typeof data[k] === 'string') out[k] = data[k];
      });
      cached = out;
      return cached;
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[runtimeEnv] Could not load config/publicEnv:', e?.message);
    }
  }
  return {};
}
